module.exports = __webpack_public_path__ + "img/classic_rental20_3.2b7362bf.jpg";